module.exports = __webpack_public_path__ + "media/img/logo_footer@3x-fcf46188.svg";